export default () => {
  const buttons = document.querySelectorAll('.js-go-back')
  if (buttons.length < 1) return
  ;[...buttons].forEach(button => {
    button.addEventListener('click', e => {
      e.preventDefault()

      if (document.referrer.indexOf(window.location.host) !== -1) {
        window.history.go(-1)
      } else {
        window.location = 'https://mattador.nl/alle-producten/'
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/js/modules/GoBack.js